import { CanDeactivateInformationPage } from '../information-page/can-deactivate.service';
import { ProductGroupsComponent } from './components/product-groups/product-groups.component';
import { MarketingComponent } from './components/marketing/marketing.component';
import { PriceSheetsComponent } from './components/price-sheets/price-sheets.component';
import { CoreComponent } from './components/core/core.component';


export const brandInformationRoutes = [
  {
    path: '',
    component: ProductGroupsComponent,
    canDeactivate: [CanDeactivateInformationPage],
  },
  {
    path: 'product-groups',
    component: ProductGroupsComponent,
    canDeactivate: [CanDeactivateInformationPage],
  },
  {
    path: 'marketing',
    component: MarketingComponent,
    canDeactivate: [CanDeactivateInformationPage],
    showUpdatePublished: true,
  },
  {
    path: 'price-sheets',
    component: PriceSheetsComponent,
    canDeactivate: [CanDeactivateInformationPage],
    showUpdatePublished: true,
  },
  {
    path: 'core',
    component: CoreComponent,
    canDeactivate: [CanDeactivateInformationPage],
  }
];
